import React from 'react';
import { generatePath, Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import routes from '../../../routes';
import AdminDashboardAppConfigurationTable from './Components/AdminDashboardAppConfigurationTable';
import { Colors } from '../../../assets/theme/Colors';
import AdminDashboardActivity from './Components/AdminDashboardActivity';

const linkSx = {
  textDecoration: 'none',
  color: Colors.gray,
  paddingLeft: '10px',
  '&.active': {
    color: 'primary.main',
    position: 'relative',
    '&:before': {
      content: '""',
      position: 'absolute',
      left: -3,
      top: 0,
      height: '100%',
      borderLeft: '4px solid',
      borderColor: 'primary.main',
    },
  },
};

const AdminDashboardDesktop = () => {
  const { url } = useRouteMatch();

  const dashboardNavList = [
    {
      name: 'App Configuration',
      component: AdminDashboardAppConfigurationTable,
      path: generatePath(routes.dashboardAdmin, { tab: 'app-config' }),
    },
    {
      name: 'Activity',
      component: AdminDashboardActivity,
      path: generatePath(routes.dashboardAdmin, { tab: 'activity' }),
    },
  ];

  const paths = dashboardNavList.map((item) => item.path);

  const getActiveTab = () => {
    const path = paths.indexOf(url);

    return Math.max(path, 0);
  };

  return (
    <>
      <Typography variant="h5">My Dashboard</Typography>
      <Box mt={5} display="flex" gap="16px">
        <Box minWidth="max-content">
          {dashboardNavList.map((item, index) => (
            <Typography variant="subtitle2" key={item.name} gutterBottom>
              <Box
                sx={linkSx}
                component={Link}
                className={index !== getActiveTab() ? '' : 'active'}
                to={item.path}
                key={item.name}
              >
                {item.name}
              </Box>
            </Typography>
          ))}
        </Box>
        <Box sx={{ width: 'calc(100% - 170px)' }}>
          <Switch>
            {dashboardNavList.map((item, index) => (
              <Route
                exact
                path={index === 0 ? [generatePath(routes.dashboardAdmin), item.path] : item.path}
                component={item.component}
                key={item.name}
              />
            ))}
          </Switch>
        </Box>
      </Box>
    </>
  );
};

export default AdminDashboardDesktop;
